import { buttonStyles, type models } from '../models';
import { Modal } from './modal';

export class PopUpModal extends Modal {
  /**
   * render modal
   */
  public render(rewardMessage: models.RewardMessage) {
    this.modalDiv = document.createElement('div');
    this.modalDiv.className = 'modal-blur-wrapper';

    const modalBoxDiv: HTMLDivElement = document.createElement('div');
    modalBoxDiv.classList = 'modal-box pop-up-box';

    if (!!rewardMessage.UrlToImage) {
      const image: HTMLImageElement = document.createElement('img');
      image.src = `${rewardMessage.UrlToImage}`;
      image.className = 'pop-up-image';
      modalBoxDiv.appendChild(image);
    }

    const box: HTMLDivElement = document.createElement('div');
    box.className = 'pop-up-box-content';
    modalBoxDiv.appendChild(box);

    if (this.showCloseButton()) {
      this._renderCloseButton(box);
    }

    const title: HTMLDivElement = document.createElement('div');
    title.classList = 'modal-title pop-up-title';
    title.textContent = rewardMessage.Title as string;
    box.appendChild(title);

    const text: HTMLDivElement = document.createElement('div');
    text.classList = 'modal-text pop-up-text';
    text.textContent = rewardMessage.Text as string;
    box.appendChild(text);

    this._renderButtons(rewardMessage, box);

    if (!this.automaticClose()) {
      modalBoxDiv.addEventListener('click', event => event.stopPropagation());
    }

    this.modalDiv.appendChild(modalBoxDiv);

    if (!this.automaticClose()) {
      this.modalDiv.addEventListener('click', () => this.closeModal());
    }

    document.body.append(this.modalDiv);
  }

  private _renderCloseButton(box: HTMLDivElement) {
    const closeButton: HTMLButtonElement = document.createElement('button');
    closeButton.className = 'pop-up-close-button';
    box.appendChild(closeButton);

    const iconDiv: HTMLDivElement = document.createElement('div');
    iconDiv.innerHTML = this.closeSvgIconBig;

    closeButton.appendChild(iconDiv);

    const closeWraper = () => this.closeModal();
    closeButton.addEventListener('click', closeWraper);

    this.addButton(closeButton, closeWraper);
  }

  private _renderButtons(
    rewardMessage: models.RewardMessage,
    box: HTMLDivElement
  ) {
    const buttonsDiv: HTMLDivElement = document.createElement('div');
    box.appendChild(buttonsDiv);
    buttonsDiv.className = 'pop-up-buttons';

    rewardMessage.RewardButtons?.forEach(rewardButton => {
      const btn = this.buttonsAsLinks
        ? (document.createElement('a') as HTMLAnchorElement)
        : (document.createElement('button') as HTMLButtonElement);
      const styleVale: string = (
        !!rewardButton?.Style ? buttonStyles[rewardButton?.Style] : ''
      ).toLocaleLowerCase();
      btn.classList = `modal-confirm-button pop-up-confirm-button modal-button-${styleVale}`;
      btn.textContent = rewardButton.Text as string;
      const clickWraper = () =>
        this.handleClick(rewardButton.Type, rewardButton.Parameters);
      if (!!rewardButton.Type && !this.buttonsAsLinks) {
        btn.addEventListener('click', clickWraper);
      }
      if (this.buttonsAsLinks && btn instanceof HTMLAnchorElement) {
        this._addHrefToLink(rewardButton, btn);
      }
      buttonsDiv.appendChild(btn);

      if (!this.buttonsAsLinks && btn instanceof HTMLButtonElement) {
        this.addButton(btn, clickWraper);
      }
    });
  }
}
